// extracted by mini-css-extract-plugin
export default {"links":"TireConfig_links__ECi1x","sectionHeadings":"TireConfig_sectionHeadings__AQsit","hr":"TireConfig_hr__D-lCo","retread":"TireConfig_retread__OKNsx"};